exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2rRqAC42V8SQYq0WQ-KmkV .ms-button{width:46px}._2rRqAC42V8SQYq0WQ-KmkV .ms-button-flexContainer{display:block}._2rRqAC42V8SQYq0WQ-KmkV ._39nhyOUZyhpxQlja63IJ7W{width:46px}._2rRqAC42V8SQYq0WQ-KmkV ._3fEskzBitZcwoC-k1ZllWd{position:absolute;top:0}html[dir=ltr] ._2rRqAC42V8SQYq0WQ-KmkV ._3fEskzBitZcwoC-k1ZllWd{left:-2px}html[dir=rtl] ._2rRqAC42V8SQYq0WQ-KmkV ._3fEskzBitZcwoC-k1ZllWd{right:-2px}._2rRqAC42V8SQYq0WQ-KmkV ._1A1D0slrg1vjA_b7_w36N-{position:absolute;top:0}html[dir=ltr] ._2rRqAC42V8SQYq0WQ-KmkV ._1A1D0slrg1vjA_b7_w36N-{left:14px}html[dir=rtl] ._2rRqAC42V8SQYq0WQ-KmkV ._1A1D0slrg1vjA_b7_w36N-{right:14px}", ""]);

// exports
exports.locals = {
	"attachButton": "_2rRqAC42V8SQYq0WQ-KmkV",
	"attachToolbarButton": "_39nhyOUZyhpxQlja63IJ7W",
	"attachImage": "_3fEskzBitZcwoC-k1ZllWd",
	"chevronImage": "_1A1D0slrg1vjA_b7_w36N-"
};